import Tabs, { TabsProps } from 'antd/lib/tabs';
import React, { useMemo, useState } from 'react';
import { ISavedFilter } from '../../../../components/sidebar-filters/saved-filter/interface';
import { useEnergyUsageSidebarFiltersContext } from '../context/EnergyUsageSidebarFiltersContext';
import { EnergyUsageSidebarFilters } from './EnergyUsageSidebarFilters';
import { EnergyUsageSidebarSaved } from './EnergyUsageSidebarSaved';

interface IEnergyUsageSidebarFilterTabsProps {
    onOpenSaveFiltersModal: (filter: ISavedFilter) => void;
}

export const EnergyUsageSidebarFilterTabs: React.FC<IEnergyUsageSidebarFilterTabsProps> = ({ onOpenSaveFiltersModal }) => {
    const [activeTab, setActiveTab] = useState<string>('filters');

    const handleTabChange = (key: string) => {
        setActiveTab(key);
    };

    const tabs: TabsProps['items'] = [
        {
            key: 'filters',
            label: <FiltersLabel />,
            children: <EnergyUsageSidebarFilters />,
        },
        {
            key: 'saved',
            label: <SavedLabel />,
            children: <EnergyUsageSidebarSaved onOpenSaveFiltersModal={onOpenSaveFiltersModal} />,
        },
    ];

    return (
        <Tabs
            activeKey={activeTab}
            onChange={handleTabChange}
            defaultActiveKey="filters"
            destroyOnHidden={false}
            items={tabs}
            tabBarStyle={{ marginBottom: 0, padding: '0px 8px' }}
        />
    );
};

// This components helps to less re-rendering and improve performance
const FiltersLabel: React.FC = () => {
    const { siteFiltersCount } = useEnergyUsageSidebarFiltersContext();

    return <span>Filters {siteFiltersCount > 0 ? `(${siteFiltersCount})` : ''}</span>;
};

const SavedLabel: React.FC = () => {
    const { savedFilters } = useEnergyUsageSidebarFiltersContext();
    const savedFiltersCount = useMemo(() => savedFilters.length, [savedFilters]);

    return <span>Saved {savedFiltersCount > 0 ? `(${savedFiltersCount})` : ''}</span>;
};
